
<div class="modal active flightInspectionComp">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2 *ngIf="!isProcessingTool">Flight Inspection Import Options</h2>
      <h2 *ngIf="isProcessingTool">Processing Tool Import Menu</h2>
      <div class="close" (click)="cancelflightInspectionImport()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  *ngIf="importConfig != null"name="ngFlightInspectionForm" #ngForm="ngForm" id="flightInspectionForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>File Source</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">File Name</label>
                  <input
                  style="padding-left: 0px;"
                  maxlength="300"
                  type="text"
                  name="filename"
                  id="filename"
                  [(ngModel)]="this.fileName"
                />
                </div>
                <div *ngIf="!isProcessingTool"><label for="">Decimate</label><input id="Decimate" name="decimate" type="checkbox"  [(ngModel)]="importConfig.fileConfiguration.decimate" ></div>
                <div *ngIf="!isProcessingTool"><label for="">One sample by each:</label><input name="decimateSample" [disabled]="!importConfig.fileConfiguration.decimate" [required]="importConfig.fileConfiguration.decimate" [(ngModel)]="importConfig.decimateSample" type="number" /></div>
                <div *ngIf="isProcessingTool"><input id="Decimate" name="decimate" type="checkbox"  [(ngModel)]="importConfig.decimate" ><label for="">Decimate</label></div>
                <div *ngIf="isProcessingTool"><label for="">One sample by each:</label><input name="decimateSample" [disabled]="!importConfig.decimate" [required]="importConfig.decimate" [(ngModel)]="importConfig.decimateSample" type="number" /></div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Layer Settings</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div><label for="">Layer Name</label><input type="text" name="layerName" id="layerName" [(ngModel)]="this.layerName" /></div>
                <label *ngIf="this.layerName.length > 20" style="color: red;">Layer Name cannot exceed 20 characters.</label>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Configured Fields to Import</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div style="margin-top: 5px;">
                  <label for=""></label>
                  <div class="btn">
                    <button (click)="isProcessingTool? openPTConfigureFormat():openConfigureFormat()" >Configure Flight Inspection Format</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid && config && this.layerName.length <= 20 ? 'blue' : 'gray'" [disabled]="!ngForm.form.valid || !config || this.layerName.length > 20"
            (click)="isProcessingTool? performOkProcessingTool() : ok()">
              OK
            </button>
            <button class="gray" (click)="cancelflightInspectionImport()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
